import React from "react";
import { Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useMap } from "react-leaflet";
import { colors } from "../../../styles/theme";

/**
 * Custom Zoom-Control im Stil des Refresh-Buttons
 * Positioniert links unten auf der Karte
 */
const CustomZoomControl: React.FC = () => {
  const map = useMap();

  const handleZoomIn = () => {
    map.zoomIn();
  };

  const handleZoomOut = () => {
    map.zoomOut();
  };

  const buttonStyle = {
    backgroundColor: colors.glass.backgroundSolid,
    borderRadius: "50%",
    width: 40,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: colors.background.paper,
      transform: "scale(1.1)",
    },
  };

  const iconStyle = {
    fontSize: 20,
    color: colors.primary.main,
  };

  return (
    <Box
      sx={{
        position: "absolute",
        top: 20,
        left: 20,
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {/* Zoom In Button */}
      <Box sx={buttonStyle} onClick={handleZoomIn}>
        <AddIcon sx={iconStyle} />
      </Box>

      {/* Zoom Out Button */}
      <Box sx={buttonStyle} onClick={handleZoomOut}>
        <RemoveIcon sx={iconStyle} />
      </Box>
    </Box>
  );
};

export default CustomZoomControl;
